import {
	GlobalExtension,
	type GlobalExtensionType,
	type ForgeUIExtensionType,
} from '@atlassian/forge-ui-types/private';

// Use the FullForgeUIExtensionType from createNavigateTargetPath.ts which now includes installationId
type GlobalFullForgeUIExtensionType = ForgeUIExtensionType & {
	installationId?: string;
	properties: ForgeUIExtensionType['properties'] & {
		routePrefix?: string;
	};
};

export const globalExtensionURLHelpers: Partial<
	Record<
		GlobalExtensionType,
		(extension: GlobalFullForgeUIExtensionType, params?: any) => string | null
	>
> = {
	[GlobalExtension.FULL_PAGE]: ({ installationId, properties }) => {
		const { routePrefix } = properties;
		if (!routePrefix || !installationId) {
			return null;
		}
		return `/apps/full-page/${installationId}/${routePrefix}`;
	},
	[GlobalExtension.GLOBAL_UI]: ({ installationId }) => {
		if (!installationId) {
			return null;
		}
		return `/apps/${installationId}`;
	},
};
